import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { CommonData } from '../../providers/common-data';
import { UserData } from '../../providers/user-data';
import moment from 'moment';
import { ToastController } from 'ionic-angular';
import { Http } from '@angular/http';
import { MandantenData } from '../../providers/mandanten-data';

/**
 * Generated class for the AdminPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-admin',
  templateUrl: 'admin.html',
})
export class AdminPage {
  dBegin;
  dEnd;
  user_email;
  mandat_id;
  anzahlQR;
  showVerrechnenButton;
  constructor(public navCtrl: NavController, public navParams: NavParams
    , public common: CommonData
    , public userData: UserData
    , public mandData: MandantenData
    , public toastCtrl: ToastController
    , public http: Http
    , public loadingCtrl: LoadingController
    ) {
      this.showVerrechnenButton = false;
      let d = moment();
      this.anzahlQR = 1;
      //d.add(1, "day");
      //d.set({hour:10,minute:0,second:0,millisecond:0})
      //this.dBegin = d.toISOString();   
      this.dBegin = d.subtract(2,'months').endOf('month').add(1,'days').hours(5).minutes(0).seconds(0).milliseconds(0).toISOString(); 
      //console.log(this.dBegin);
      let d2 = moment();
      d2.set({hour:23,minute:59,second:59,millisecond:0})
      this.dEnd = d2.subtract(1,'months').endOf('month').hours(21).minutes(0).seconds(0).milliseconds(0).toISOString(); 

  }

  ionViewDidLoad() {
    this.showVerrechnenButton = false;
  }
  rechnungErzeugen(){
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,user: this.user_email
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Rechungen werden vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Rechungen erzeugen fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'rechnungen_erzeugen.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          //console.log(data);
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });  
  }

  mahnungenErzeugen(){
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,user: this.user_email
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Mahnungen werden vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Mahnungen erzeugen fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'mahnung_erzeugen.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          //console.log(data);
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });   
  }

  verrechnenUE(){
    //-- wird aktuell wieder im report (abrechnung) gemacht -------
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,mandid: this.mandat_id
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'UEs werden werden als bezahlt markiert, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, UE bezahlt markieren fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.baseurl+'bussen/verrechnet',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          //console.log(data);
          this.showVerrechnenButton = !data.success ;
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim UE bezahlt markieren',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim UE bezahlt markieren',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });       
  }

  rnuErzeugen(){
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,user: this.user_email
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'RnUs werden vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, RnU erzeugen fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'rechnungnachurteil_erzeugen.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          //console.log(data);
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });        
  }

  
  pbRenewErzeugen(){
    return new Promise(resolve => {
      var data = JSON.stringify({
        user: this.user_email
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Verlängerungsinfos werden vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Verlängerungsinfos erzeugen fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.baseurl+'pbperioden/createrenewreminderpdfs',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          console.log(data);
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });        
  }
  anzeigenErzeugen(){

    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,user: this.user_email
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Anzeigen werden vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Anzeigen erzeugen fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'anzeigen_erzeugen.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          console.log(data);
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });    

  }


  abrechnungErzeugen(){
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,user: this.user_email
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout1 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Abrechnung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'abrechnung.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let data = response.json();
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout1);
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });
  }

  abrechnungMandat(update_verrechnet = false){
    //report.php, mandat_id
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,mandid: this.mandat_id
        ,token: this.userData.jwt
        ,update_verrechnet : update_verrechnet
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Abrechnung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 60000);


      this.http.post(this.common.ubsurl+'report.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          let data = response.json();
          if(!update_verrechnet){
            this.showVerrechnenButton = data.success;
          }
          else{
            this.showVerrechnenButton = false;
          }
          
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 5000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });    
  }

  abrechnungMandatYear(){
    //report.php, mandat_id
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,mandid: this.mandat_id
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Abrechnung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'report_year.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          let data = response.json();
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });    
  }

  kontrollBericht(){
    //report.php, mandat_id
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,mandid: this.mandat_id
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Kontrollbericht fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'kontrollbericht.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          let data = response.json();
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });    
  }  
  
  qrRechnungen(){
    //report.php, mandat_id
    return new Promise(resolve => {
      var data = JSON.stringify({
        mandid: this.mandat_id
        ,anzahl: this.anzahlQR
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Abrechnung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'rechnungenqr_erzeugen.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          console.log(response);
          let data = response.json();
          
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });        
  }  

  qrRechnungenA6(){
    return new Promise(resolve => {
      var data = JSON.stringify({
        mandid: this.mandat_id
        ,anzahl: this.anzahlQR
        ,token: this.userData.jwt
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Generierung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'rechnungenqra6_erzeugen.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          console.log(response);
          let data = response.json();
          
          if(data.success === true){
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });        
  }    

}



// WEBPACK FOOTER //
// ./src/pages/admin/admin.ts